import styled from 'styled-components'
import theme from 'theme_'

export const DateCardFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px 16px 16px;
  gap: ${theme.spacing.base};
  margin-bottom: 15px;

  max-width: 1119px;
  height: 132px;

  /* White */
  background: #ffffff;
  /* Shadow small */
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
    height: 400px;
  }
`

export const DateCardPlaceholder = styled.div`
  width: 100%;
`
